import axios from 'axios';
import store from '../store';

const getApiBaseUrl = () => {
	if (typeof window !== 'undefined') {
		const { hostname } = window.location;
		if (hostname === 'localhost' || hostname === '127.0.0.1') {
			return 'http://localhost:5000/api';
		}
	}

	const envUrl = process.env.REACT_APP_BASE_URL || 'https://appapi.albionline.com/api/';
	return envUrl.replace(/\/+$/, '');
};

const axiosIntance = axios.create({
	baseURL: getApiBaseUrl(),
});

axiosIntance.interceptors.request.use((req) => {
	if (req.url?.includes('verify-app-token')) {
		console.log('[axios] verify-app-token ->', `${req.baseURL || ''}${req.url}`);
	}
	return req;
});

axiosIntance.interceptors.response.use((res) => {
    return res;
}, (error) => {
    console.log(error.response);
    return Promise.reject(error);
})

export default axiosIntance;
